// extracted by mini-css-extract-plugin
export default {"title":"SubsidyInfo_title__S-IOT","content":"SubsidyInfo_content__igvR-","footer":"SubsidyInfo_footer__b5FSh","placeHolderShimmer":"SubsidyInfo_placeHolderShimmer__kIrhl"};